<template>
  <div class="min-h-screen bg-gray-50">
    <NavbarSkeleton />
    <div class="flex items-start justify-between">
      <div
        :class="[
          'w-full min-w-0 flex flex-col transition-all duration-300 gap-8',
          'lg:w-full'
        ]"
      >
        <div>
          <!-- Hero Skeleton -->
          <div class="h-64 bg-gray-200 animate-pulse"></div>

          <!-- Order Options Skeleton -->
          <div class="sticky z-30 bg-white shadow-sm" style="top: 80px">
            <div class="h-16 bg-gray-200 animate-pulse"></div>
          </div>

          <!-- Main Content Skeleton -->
          <main class="container mx-auto px-4 pt-8 -mt-10">
            <div class="flex items-start gap-8">
              <!-- Desktop Left Vertical Nav Skeleton -->
              <div
                class="hidden lg:block w-64 shrink-0 sticky"
                style="top: 140px; max-height: calc(100vh - 140px)"
              >
                <div class="space-y-4">
                  <div
                    v-for="i in 8"
                    :key="i"
                    class="h-10 bg-gray-200 rounded-lg animate-pulse"
                  ></div>
                </div>
              </div>

              <!-- Menu Sections Skeleton -->
              <div class="flex-1 min-w-0 pb-20 space-y-12">
                <div v-for="i in 3" :key="i" class="space-y-6">
                  <!-- Category Title Skeleton -->
                  <div
                    class="h-8 w-48 bg-gray-200 rounded-lg animate-pulse"
                  ></div>

                  <!-- Items Grid Skeleton -->
                  <div
                    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
                  >
                    <div
                      v-for="j in 6"
                      :key="j"
                      class="bg-white rounded-xl shadow-sm overflow-hidden"
                    >
                      <!-- Image Skeleton -->
                      <div class="w-full h-48 bg-gray-200 animate-pulse"></div>
                      <!-- Content Skeleton -->
                      <div class="p-4 space-y-3">
                        <div
                          class="h-6 bg-gray-200 rounded animate-pulse"
                        ></div>
                        <div
                          class="h-4 bg-gray-200 rounded w-3/4 animate-pulse"
                        ></div>
                        <div
                          class="h-5 bg-gray-200 rounded w-1/4 animate-pulse"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarSkeleton from "@/components/Skeletons/NavbarSkeleton.vue";
export default {
  name: "OrderViewSkeleton",
  components: {
    NavbarSkeleton
  }
};
</script>

<style></style>
